const PUSH_SUBSCRIPTION_KEY = 'ka:push-subscribed';
const VAPID_KEY_ENDPOINT = `${
  process.env.REACT_APP_API_URL || 'http://localhost:3000'
}/api/push/vapid-public-key`;
const SUBSCRIBE_ENDPOINT = `${
  process.env.REACT_APP_API_URL || 'http://localhost:3000'
}/api/push/subscribe`;
const UNSUBSCRIBE_ENDPOINT = `${
  process.env.REACT_APP_API_URL || 'http://localhost:3000'
}/api/push/unsubscribe`;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

async function getOrRegisterSW() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const existing = await navigator.serviceWorker.getRegistration('/sw.js');
    if (existing) return existing;
    return await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  } catch (err) {
    console.warn('[webPushClient] SW register failed:', err.message);
    return null;
  }
}

async function fetchVapidPublicKey() {
  const res = await fetch(VAPID_KEY_ENDPOINT, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch VAPID public key');
  const data = await res.json();
  return data.publicKey;
}

export async function subscribePush(userId, userType = 'admin') {
  if (!('PushManager' in window)) return null;
  if (!userId) return null;

  // Only request permission and subscribe once per session.
  if (sessionStorage.getItem(PUSH_SUBSCRIPTION_KEY)) return null;

  try {
    if (Notification.permission === 'denied') return null;

    if (Notification.permission === 'default') {
      const result = await Notification.requestPermission();
      if (result !== 'granted') return null;
    }

    const reg = await getOrRegisterSW();
    if (!reg) return null;

    const vapidPublicKey = await fetchVapidPublicKey();
    const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);

    // Check if already subscribed.
    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
      });
    }

    // Send subscription to backend.
    const res = await fetch(SUBSCRIBE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        subscription: subscription.toJSON(),
        userId: String(userId),
        userType,
      }),
    });

    if (res.ok) {
      sessionStorage.setItem(PUSH_SUBSCRIPTION_KEY, '1');
    }

    return subscription;
  } catch (err) {
    console.warn('[webPushClient] subscribe failed:', err.message);
    return null;
  }
}

export async function unsubscribePush() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    if (!reg) return;
    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return;

    await fetch(UNSUBSCRIBE_ENDPOINT, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ endpoint: subscription.endpoint }),
    });

    await subscription.unsubscribe();
    sessionStorage.removeItem(PUSH_SUBSCRIPTION_KEY);
  } catch (err) {
    console.warn('[webPushClient] unsubscribe failed:', err.message);
  }
}
